export function getGoogleAuthErrorMessage (error) {
  switch (error?.code) {
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
      return null
    case 'auth/network-request-failed':
      return 'Google sign-in couldn\'t connect. A VPN, firewall, or browser privacy setting may be blocking it.'
    case 'auth/web-storage-unsupported':
      return 'Your browser doesn\'t support web storage. Review your browser settings.'
    case 'auth/popup-blocked':
      return 'Your browser blocked the Google sign-in popup. Allow popups for this site and try again.'
    default:
      // null for unhandled errors in case someone combines sign/login usage with other api calls and those throw.
      return null
  }
}
